var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"sigPad\"><div class=\"sig sigWrapper\"><canvas style=\"width: 100%; height: 78px;\" class=\"pad\"></canvas></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/freeforms/signature/signature.jade
// module id = 357
// module chunks = 0